import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import DocumentNavigation from 'components/DocumentNavigation/DocumentNavigation';
import DocumentsSubHeader from 'components/DocumentsSubHeader';
import GeneralMUITableWrapper from 'components/GeneralMUITableWrapper';
import { DOCUMENT_TYPE } from 'constants/general';
import ROUTES from 'constants/routes';
import useDocumentsStatuses from 'hooks/useDocumentsStatuses';
import { RootStateType } from 'store/reducers';
import { ListingViewsTabs, TableRowsType } from 'types/Mui';
import { createTableData } from 'utils/dataColumns';

const Documents = () => {
  const { documents, documentsExecuted } = useSelector((state: RootStateType) => state.user);
  const [documentsRows, setDocumentsRows] = useState<TableRowsType>([]);

  const {
    isUserReadOnly,
    activeStatuses,
    setActiveStatuses,
  } = useDocumentsStatuses();

  useEffect(() => {
    if (activeStatuses.length > 0) {
      setDocumentsRows(createTableData(documentsExecuted, DOCUMENT_TYPE, activeStatuses));
    } else {
      setDocumentsRows(createTableData(documents, DOCUMENT_TYPE));
    }
  }, [documents, activeStatuses, documentsExecuted]);

  return (
    <>
      <DocumentsSubHeader
        title="Documents"
        buttonText="Create Document Template"
        buttonLink={ROUTES.DOCUMENTS_EDITOR}
        secondButtonText="Single Document"
        secondButtonLink={ROUTES.DOCUMENTS_EXECUTED_EDITOR_SINGLE}
      />
      <DocumentNavigation
        activeTab={activeStatuses}
        setActiveTab={setActiveStatuses}
        isUserReadOnly={isUserReadOnly}
      />
      <div className="w-75 mx-auto pb-5">
        <GeneralMUITableWrapper
          tableRows={documentsRows}
          isAllDocumentsTab={!activeStatuses.length}
          currentTableTab={ListingViewsTabs.DOCUMENTS}
          setActiveTab={setActiveStatuses}
          activeStatuses={activeStatuses}
        />
      </div>
    </>
  );
};

export default Documents;